// --Email (support@findbugzero.com), Phone(866BUGZERO), Form(Defined in ss), Knowledge base (tbd)
export default [
  {
    question: 'Phone support',
    answer: 'Call us at +1 (866) BUGZERO (284-9376)'
  }
  // {
  //   question: 'Email support',
  //   answer: 'Email us at <a href="support@findbugzero.com">support@findbugzero.com</a>',
  //   divider: false
  // }
];
